import { useEffect, useState } from "react";
import useFingerPrint from "./useFingerPrint";
import TagManager from "react-gtm-module";
import track from "../tracking/analytics";

const tagManagerArgs = {
  gtmId: process.env.GTM_ID,
};

const fbArgs = {
  autoConfig: true,
  debug: false,
};

const useAnalytics = (isIframeMode) => {
  const [getScriptInjectTimer, setScriptInjectTimer] = useState(0);

  useFingerPrint(true);
  useEffect(() => {
    track("pageview");
    !isIframeMode && awaitScriptInjection();
    return () => {
      clearTimeout(getScriptInjectTimer);
    };
  }, []);

  const awaitScriptInjection = () => {
    if (typeof window !== "undefined") {
      if (window.performance.timing.loadEventEnd === 0) {
        if (!getScriptInjectTimer) {
          setScriptInjectTimer(
            window.setTimeout(() => awaitScriptInjection(), 500)
          );
        }
      } else if (window.fbq === undefined) {
        TagManager.initialize(tagManagerArgs);
        const ReactPixel = require("react-facebook-pixel");
        ReactPixel.default.init(process.env.PIXEL_ID, null, fbArgs);
      }
    }
  };
};

export default useAnalytics;
